import { render } from "./FileTypeIcon.vue?vue&type=template&id=49f8e6b8&scoped=true"
import script from "./FileTypeIcon.vue?vue&type=script&lang=js"
export * from "./FileTypeIcon.vue?vue&type=script&lang=js"

import "./FileTypeIcon.vue?vue&type=style&index=0&id=49f8e6b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f8e6b8"]])

export default __exports__